import { DateTime, Duration } from "luxon";

import { padNumber, secondsToHourMinuteSecond } from "@/utils";

export function toTimeString(time: number) {
  if (!time || time === 0) {
    return "00:00";
  }
  if (time > Duration.fromObject({ hours: 1 }).as("seconds")) {
    const timeObject = secondsToHourMinuteSecond(time);
    return `${timeObject.h}:${padNumber(timeObject.m)}:${padNumber(Math.floor(timeObject.s))}`;
  }
  // Seconds past 59 overflow into minutes, and an hour or more into hours, which the slice then drops.
  const date = DateTime.now().set({ hour: 0, minute: 0, second: time });
  return date.toJSDate().toTimeString().slice(3, 8);
}
